export default {
  title: 'geissendoerfer.web App'
};
